export default __webpack_public_path__ + "static/media/nophoto2.2d85be1a.png";